(() => {
  if (window.__emB2BGuardLoaded) return;
  window.__emB2BGuardLoaded = true;

  const state = document.querySelector('[data-em-b2b-state]');
  if (!state || state.dataset.status !== 'blocked') return;

  const reason = state.dataset.reason || 'login';
  const copy = {
    login: {
      title: 'Preise für verifizierte Fachkunden',
      text: 'Bitte melden Sie sich mit Ihrem freigeschalteten EcoMedic Fachkundenkonto an.',
      link: '/account/login',
      cta: 'Einloggen & Preise sehen'
    },
    pending: {
      title: 'Fachkundenzugang wird geprüft',
      text: 'Ihre Registrierung ist eingegangen. Preise und Bestellfunktionen werden nach manueller Freigabe durch EcoMedic aktiviert.',
      link: '/account',
      cta: 'Zum Kundenkonto'
    },
    not_approved: {
      title: 'Fachkundenzugang erforderlich',
      text: 'Dieses Kundenkonto ist noch nicht als EcoMedic Fachkunde freigeschaltet.',
      link: '/pages/fachkunden-registrierung',
      cta: 'Fachkundenzugang beantragen'
    },
    circadia: {
      title: 'Circadia Partnerzugang erforderlich',
      text: 'Circadia Preise sind ausschließlich für freigeschaltete Circadia Partner sichtbar.',
      link: '/pages/circadia-fachkunden-registrierung',
      cta: 'Circadia Partnerzugang beantragen'
    }
  }[reason] || null;

  if (!copy) return;

  const lockIcon = '<span class="em-b2b-gate__compact-icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="10" width="14" height="10" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path></svg></span>';

  const registrationFor = (brand) => brand === 'circadia'
    ? ['/pages/circadia-fachkunden-registrierung', 'Partnerzugang']
    : brand === 'hydrafacial'
      ? ['/pages/hydrafacial-fachkunden-registrierung', 'Zugang beantragen']
      : ['/pages/fachkunden-registrierung', 'Zugang beantragen'];

  const compactData = (brand = 'general') => {
    const registration = registrationFor(brand);
    if (reason === 'pending') return ['Freigabe wird geprüft', 'Preise nach manueller Freigabe', '/account', 'Zum Kundenkonto', '', ''];
    if (reason === 'not_approved') return ['Fachkundenzugang erforderlich', 'Dieses Konto ist noch nicht freigeschaltet', registration[0], 'Zugang beantragen', '', ''];
    if (reason === 'circadia') return ['Circadia Partnerzugang erforderlich', 'Preis nur für freigegebene Circadia Partner', '/pages/circadia-fachkunden-registrierung', 'Partnerzugang beantragen', '', ''];
    if (brand === 'circadia') return ['Preis nur für Circadia Partner', 'Nach Partnerfreigabe sichtbar', '/account/login', 'Einloggen', registration[0], registration[1]];
    return ['Preis nur für EcoMedic Fachkunden', 'Nach Login sichtbar', '/account/login', 'Einloggen', registration[0], registration[1]];
  };

  const gateHtml = (compact = false, brand = 'general') => {
    if (compact) {
      const data = compactData(brand);
      const secondary = data[4] ? `<span class="em-b2b-gate__compact-divider" aria-hidden="true">·</span><a href="${data[4]}">${data[5]}</a>` : '';
      return `<div class="em-b2b-gate em-b2b-gate--compact" data-em-b2b-runtime-gate>${lockIcon}<span class="em-b2b-gate__compact-body"><strong>${data[0]}</strong><span class="em-b2b-gate__compact-note">${data[1]}</span><span class="em-b2b-gate__compact-actions"><a href="${data[2]}">${data[3]}</a>${secondary}</span></span></div>`;
    }

    const secondary = reason === 'login' ? '<a class="em-b2b-gate__secondary" href="/pages/fachkunden-registrierung">Fachkundenzugang beantragen</a>' : '';
    return `<div class="em-b2b-gate em-b2b-gate--full" data-em-b2b-runtime-gate><span class="em-b2b-gate__eyebrow">ECOMEDIC FACHKUNDENBEREICH</span><strong>${copy.title}</strong><p>${copy.text}</p><div class="em-b2b-gate__actions"><a class="em-b2b-gate__primary" href="${copy.link}">${copy.cta}</a>${secondary}</div></div>`;
  };

  function injectGates(root = document) {
    root.querySelectorAll('.em-product-premium .em-price-wrap').forEach((el) => {
      if (el.querySelector('[data-em-b2b-gate], [data-em-b2b-runtime-gate]')) return;
      el.innerHTML = gateHtml(false, 'general');
    });

    root.querySelectorAll('.em-circadia-products .em-price-area').forEach((el) => {
      if (el.querySelector('[data-em-b2b-gate], [data-em-b2b-runtime-gate]')) return;
      el.innerHTML = gateHtml(true, 'circadia');
    });

    const cartRoot = root.querySelector('.mini-cart__inner, cart-items.page-width, #main-cart-footer');
    if (cartRoot && !cartRoot.querySelector('[data-em-b2b-cart-gate]')) {
      const gate = document.createElement('div');
      gate.dataset.emB2BCartGate = 'true';
      gate.innerHTML = gateHtml(false, 'general');
      cartRoot.prepend(gate);
    }
  }

  const appSelector = [
    '[class*="bogos"]','[id*="bogos"]','[class*="bogo-"]','[id*="bogo-"]',
    '[class*="free-gift"]','[id*="free-gift"]','[class*="quantity-break"]','[id*="quantity-break"]',
    '[class*="volume-discount"]','[id*="volume-discount"]','[class*="wholesale-pricing"]','[id*="wholesale-pricing"]',
    '[class*="b2b-wholesale"]','[id*="b2b-wholesale"]','pumper-bundle','.eco-price-block'
  ].join(',');

  function suppressOfferApps(root = document) {
    root.querySelectorAll(appSelector).forEach((el) => { el.style.setProperty('display', 'none', 'important'); });

    root.querySelectorAll('.shopify-app-block, [data-app-block], iframe').forEach((el) => {
      const text = (el.textContent || el.getAttribute('title') || '').toLowerCase();
      const looksLikeOffer = /angebot|gratis|kostenlos|free gift|mengen|staffel|quantity break|volume discount|wholesale/.test(text);
      const hasPrice = /€|eur|\b\d+[,.]\d{2}\b/.test(text);
      if (looksLikeOffer && hasPrice) el.style.setProperty('display', 'none', 'important');
    });
  }

  function blockPurchaseEvents(event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const purchase = target.closest('form[action*="/cart/add"], add-to-cart, product-form, [data-add-to-cart], [data-product-form], .em-atc, .em-mobile-atc, .em-quick-add-btn');
    if (!purchase) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  document.addEventListener('submit', blockPurchaseEvents, true);
  document.addEventListener('click', blockPurchaseEvents, true);

  const run = () => {
    injectGates(document);
    suppressOfferApps(document);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        injectGates(node.matches?.('.em-product-premium,.em-circadia-products,.mini-cart__inner,cart-items,#main-cart-footer') ? node.parentElement || node : node);
        suppressOfferApps(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();